import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";
import { monitorAndProtectNavigation } from "app/pages/digital-marketing/monitor-and-protect";

import { SI_MNP_ROUTES, SI_MNP_TRADEMARK_ROUTES } from "./constants";

export const salesMonitorAndProtectNavBarContent = (): ISecondaryBarContents =>
    monitorAndProtectNavigation({
        headerHomeState: SI_MNP_ROUTES.HOME.stateName,
        routeOverrides: {
            homeStateName: SI_MNP_ROUTES.HOME.stateName,
            overviewStateName: SI_MNP_ROUTES.OVERVIEW.stateName,
            competitorsStateName: SI_MNP_ROUTES.COMPETITORS.stateName,
            keywordsStateName: SI_MNP_ROUTES.KEYWORDS.stateName,
            adsStateName: SI_MNP_ROUTES.ADS.stateName,
            trademarkAbstractStateName: SI_MNP_TRADEMARK_ROUTES.ABSTRACT.stateName,
            trademarksStateName: SI_MNP_TRADEMARK_ROUTES.TRADEMARKS.stateName,
            violationsStateName: SI_MNP_TRADEMARK_ROUTES.VIOLATIONS.stateName,
        },
    });
